import React, { useEffect, useState } from "react";
import TreemapChart from "../../../components/Charts/TreeMapChart";
import { axInst, axInstBasic } from "../../../components/Service/Service";
import { Loader } from "rsuite";

// const workshopData = async (Arn) => {
//   const basicAuth =
//     "Basic " +
//     btoa(`${process.env.REACT_APP_UNAME}:${process.env.REACT_APP_PWD}`);
//   try {
//     const res = await axInst.post(
//       `${process.env.REACT_APP_API_URL}workShopJC`,
//       {
//         isSearchArn: Arn,
//       },
//       {
//         headers: {
//           Authorization: basicAuth,
//         },
//       }
//     );
//     return res.data.result;
//   } catch (error) {
//     console.error(
//       "API Error:",
//       error.response ? error.response.data : error.message
//     );
//     throw error;
//   }
// };
export const workshopData = async (isSearchArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}workShopJC`,{isSearchArn}
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const Workshop = ({ isSearchArn, isArn, setIsSearchArn, isWaterMark }) => {
  const [workshopTopfive, setWorkshopTopfive] = useState(null);
  const [isWaterMarkData, setIsWaterMarkData] = useState(null);

  useEffect(() => {
    if (isSearchArn && isArn) {
      workshopData(isArn)
        .then((data) => {
          setWorkshopTopfive(data); // Store fetched data
        })
        .catch((error) => {
          console.error("Error fetching total open JC:", error);
        });
    }
    setIsSearchArn(false);
  }, [isSearchArn, isArn, setIsSearchArn]);

  useEffect(() => {
    setIsWaterMarkData(isWaterMark);
  }, [isWaterMark]);

  // If data is not available, show loader
  if (!workshopTopfive) {
    return (
      <div className="grid items-center justify-center w-full h-full">
        <Loader />
      </div>
    );
  }

  // Extract treemap data from workshopTopfive (modify this based on actual data structure)
  const treemap =
    workshopTopfive?.buckets?.map((item) => ({
      name: item.key,
      value: item.doc_count,
    })) || [];

  return (
    <div className="relative">
      {isWaterMarkData && (
        <div className="absolute inset-0 flex items-center justify-center opacity-25 text-1xl text-center z-50">
          <div>
            <div>{isWaterMarkData.userId}</div>
            <div>{isWaterMarkData.date}</div>
            <div>{isWaterMarkData.ip}</div>
          </div>
        </div>
      )}
      <TreemapChart data={treemap} />
    </div>
  );
};

export default Workshop;
